import { render, staticRenderFns } from "./CurrentsContourBarComponent.vue?vue&type=template&id=704f2a3b&"
import script from "./CurrentsContourBarComponent.vue?vue&type=script&lang=js&"
export * from "./CurrentsContourBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports